import React from "react";
import { noop } from "lib/utils";
import cn from "classnames";
import { ReactComponent as DoubleArrowsIcon } from "static/images/double-arrows.svg";
import "styles/components/mobile-ticket-radio.scss";

const MobileTicketRadio = ({
  iconClassName,
  label,
  ariaLabel,
  Icon = DoubleArrowsIcon,
  name,
  onChange = noop,
  selected,
  value
}) => {
  const onInputChange = e => {
    onChange(e.target.value);
  };

  return (
    <label
      className={cn("otrl-jp__mobile-ticket-radio")}
      aria-label={ariaLabel || label}
    >
      <input
        className="otrl-jp__mobile-ticket-radio__input"
        checked={selected === value}
        type="radio"
        name={name}
        onChange={onInputChange}
        value={value}
      />
      <div
        className={cn("otrl-jp__mobile-ticket-radio__container", {
          "otrl-jp__mobile-ticket-radio__container--checked": selected === value
        })}
        aria-hidden
      >
        <Icon className={cn("otrl-jp__mobile-ticket-radio__container__icon", iconClassName)} />
        {label}
        <span className="otrl-jp__mobile-ticket-radio__container__checkmark" />
      </div>
    </label>
  );
};

export default MobileTicketRadio;
